export var ApplePayButtonColorEnumsObj = {
    BLACK: "black",
    WHITE: "white",
    WHITE_OUTLINE: "white-outline",
};
